// src/components/Cart.js
import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { X, Minus, Plus } from 'lucide-react';
import Checkout from './Checkout';

const Cart = ({ isOpen, onClose }) => {
  const { state, dispatch } = useCart();
  const [showCheckout, setShowCheckout] = useState(false);

  const updateQuantity = (item, newQuantity) => {
    if (newQuantity < 1) {
      dispatch({ type: 'REMOVE_FROM_CART', payload: item });
    } else {
      dispatch({ type: 'UPDATE_QUANTITY', payload: { ...item, quantity: newQuantity } });
    }
  };

  const total = state.items.reduce((sum, item) => {
    const price = typeof item.price === 'string'
      ? parseFloat(item.price.replace('$', ''))
      : item.price;
    return sum + price * item.quantity;
  }, 0);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      <div className="absolute inset-0 bg-[#3D2817]/40" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#FAF6EE] shadow-xl text-[#3D2817]">
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between px-6 py-5 border-b border-[#E5DCC9]">
            <h2 className="font-serif text-xl tracking-wide">Shopping Cart</h2>
            <button onClick={onClose} className="p-2 hover:bg-[#EFE7D6] rounded-full transition-colors" aria-label="Close cart">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-6">
            {state.items.length === 0 ? (
              <p className="text-center text-[#6B5644] mt-12">Your cart is empty</p>
            ) : (
              <div className="space-y-4">
                {state.items.map((item) => (
                  <div key={item.name} className="flex items-center justify-between gap-4 bg-white p-4 border border-[#E5DCC9]">
                    <div className="flex-1 min-w-0">
                      <h3 className="font-serif text-base truncate">{item.name}</h3>
                      <p className="text-sm text-[#6B5644]">${typeof item.price === 'string' ? item.price.replace('$', '') : item.price}</p>
                    </div>
                    <div className="flex items-center gap-2 text-[#3D2817]">
                      <button
                        onClick={() => updateQuantity(item, item.quantity - 1)}
                        className="p-1 hover:bg-[#EFE7D6] rounded transition-colors"
                        aria-label="Decrease quantity"
                      >
                        <Minus className="h-4 w-4" />
                      </button>
                      <span className="w-8 text-center font-medium">{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item, item.quantity + 1)}
                        className="p-1 hover:bg-[#EFE7D6] rounded transition-colors"
                        aria-label="Increase quantity"
                      >
                        <Plus className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="border-t border-[#E5DCC9] p-6 space-y-4">
            <div className="flex justify-between font-serif text-lg">
              <span>Total</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <button
              onClick={() => setShowCheckout(true)}
              disabled={state.items.length === 0}
              className="w-full bg-[#6B7C3F] text-[#FAF6EE] py-4 tracking-[0.2em] uppercase text-sm hover:bg-[#5A6A35] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Checkout
            </button>
            {showCheckout && (
              <Checkout onClose={() => setShowCheckout(false)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
